module.exports = __webpack_public_path__ + "img/big4-8.11f3792f.jpg";